var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#498467"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 20.7381C9.86363 19.4479 8.25 18.8028 8.25 18C8.25 17.1972 9.86363 16.5538 13.0909 15.2619L17.6539 13.437C20.8811 12.1451 22.4964 11.5 24.5 11.5C26.5052 11.5 28.1189 12.1451 31.3461 13.437L35.9091 15.2619C39.1364 16.5521 40.75 17.1972 40.75 18C40.75 18.8028 39.1364 19.4463 35.9091 20.7381L31.3461 22.563C28.1189 23.8565 26.5036 24.5 24.5 24.5C22.4948 24.5 20.8811 23.8549 17.6539 22.5646L13.0925 20.7365L13.0909 20.7381Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 18C8.25 18.8028 9.86363 19.4463 13.0909 20.7381L17.6539 22.563C20.8811 23.8565 22.4964 24.5 24.5 24.5C26.5052 24.5 28.1189 23.8549 31.3461 22.5646L35.9091 20.7381C39.1364 19.4479 40.75 18.8028 40.75 18C40.75 17.1972 39.1364 16.5538 35.9091 15.2619L31.3461 13.437C28.1189 12.1451 26.5036 11.5 24.5 11.5C22.4948 11.5 20.8811 12.1451 17.6539 13.437L13.0925 15.2619C9.86363 16.5521 8.25 17.1972 8.25 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14.3697 21.25L13.0909 21.7619C9.86363 23.0521 8.25 23.6989 8.25 24.5C8.25 25.3011 9.86363 25.9463 13.0909 27.2381L17.6539 29.063C20.8811 30.3565 22.4964 31 24.5 31C26.5052 31 28.1189 30.3549 31.3461 29.0646L35.9091 27.2381C39.1364 25.9479 40.75 25.3011 40.75 24.5C40.75 23.6989 39.1364 23.0537 35.9091 21.7619L34.6302 21.25L31.3461 22.5646C28.1189 23.8549 26.5036 24.5 24.5 24.5C22.4948 24.5 20.8811 23.8549 17.6539 22.5646L14.3714 21.25H14.3697Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.3697 27.75L13.0909 28.2619C9.86363 29.5521 8.25 30.1989 8.25 31C8.25 31.8028 9.86363 32.4462 13.0909 33.7381L17.6539 35.563C20.8811 36.8565 22.4964 37.5 24.5 37.5C26.5052 37.5 28.1189 36.8549 31.3461 35.563L35.9091 33.7381C39.1364 32.4479 40.75 31.8028 40.75 31C40.75 30.1989 39.1364 29.5537 35.9091 28.2619L34.6302 27.75L31.3461 29.0646C28.1189 30.3549 26.5036 31 24.5 31C22.4948 31 20.8811 30.3549 17.6539 29.0646L14.3714 27.75H14.3697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerIcon);
export default __webpack_public_path__ + "static/media/layerIcon.2735f737c188b8fc49e7334fc1fbc55b.svg";
export { ForwardRef as ReactComponent };